import { useState } from "react";
import { Row, Col } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import SearchIcon from "@material-ui/icons/Search";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import CreateClienteModal from "../clientes/CreateClienteModal";

function ClientesForm({
  clientes,
  setClientes,
  setSelectedClient,
  selectedClient,
  setLargoPelo,
  setProductsList,
  setServicesList,
}) {
  // States de la busqueda
  const [search, setSearch] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [detalle, setDetalle] = useState("")

  // Funcion encargada de la busqueda del cliente, por nombre o apellido.
  const onSearchHandler = (search) => {
    let matches = [];
    if (search.length > 0) {
      matches = clientes.filter(
        (cliente) =>
          (
            cliente.nombre.toLowerCase() +
            " " +
            cliente.apellido.toLowerCase()
          ).includes(search.toLocaleLowerCase()) ||
          (
            cliente.apellido.toLowerCase() +
            " " +
            cliente.nombre.toLowerCase()
          ).includes(search.toLocaleLowerCase())
      );
    }
    setSuggestions(matches);
    setSearch(search);
  };

  // Funcion encargada de manejar la seleccion de un cliente y agregarlo a los disabled fields
  const handleSelectCliente = (cliente) => {
    setSelectedClient(cliente);
    setLargoPelo(cliente.largo_pelo);
    setDetalle(cliente.info)
    setSearch("");
    setSuggestions([]);
  };

  // Aca manejamos la seleccion del largo del pelo del cliente, por defecto inicia en "C"
  const handleSelectLargoPelo = (e) => {
    setLargoPelo(e.target.value);
    // Aca actualizamos el largo del pelo del cliente seleccionado.
    selectedClient["largo_pelo"] = e.target.value;
  };

  const handleChangeDetalle = (e) => {
    setDetalle(e.target.value);
    selectedClient["info"] = e.target.value;
  }

  // Si usamos el boton cancelar cliente, tambien borramos los productos y servicios que se habian elegido.
  const handleCancelClient = () => {
    setSelectedClient([]);
    setProductsList([]);
    setServicesList([]);
  };

  return (
    <>
      <div className="d-flex justify-content-between">
      <h4>Cliente:</h4>
      <CreateClienteModal clientes={clientes} setClientes={setClientes} />
      </div>
      
      <Row className="d-flex justify-content-center">
        <div className="form-group col-md-6 col-sm-12">
          
          <label className="form-label mt-2 text-primary">Buscar Cliente</label>
          <div className="input-group mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Buscar por nombre o apellido"
              value={search}
              onChange={(e) => {
                onSearchHandler(e.target.value);
              }}
              
            />
            {selectedClient.length === 0 ? (
              <button className="btn btn-dark" type="submit" onClick={(e)=>{e.preventDefault()}}>
                <SearchIcon />
              </button>
            ) : (
              <button
                className="btn btn-danger"
                type="button"
                onClick={(e) => {
                  handleCancelClient(); e.preventDefault()
                }}
              >
                <CloseOutlinedIcon />
              </button>
            )}
          </div>
        </div>
      </Row>

      <Row className="d-flex justify-content-center">
        <div className="col-md-6 col-sm-12">
          <div className="list-group">
            {suggestions.length !== 0 &&

              suggestions.slice(0, 5).map((cliente) => {

                return (
                  <a
                    key={cliente.id}
                    className="list-group-item list-group-item-action pointer d-flex justify-content-center text-info"
                    onClick={(e) => {
                      handleSelectCliente(cliente);
                    }}
                  >
                    {cliente.nombre} {cliente.apellido}
                  </a>
                );
              })}
            {suggestions.length === 0 && search !== "" && (
              <a className="list-group-item list-group-item-action pointer d-flex justify-content-center text-danger">
                No hay coincidencias
              </a>
            )}
          </div>
        </div>
        <br />
      </Row>

      {selectedClient.length !== 0 && (
        <>
          <Row className="d-flex justify-content-center mt-4">
            <Form.Group className="mb-3" as={Col} lg={3}>
              <Form.Label className="text-primary">
                Cliente seleccionado:
              </Form.Label>
              <Form.Control
                className="text-info"
                value={
                  selectedClient.nombre !== undefined
                    ? `${selectedClient.nombre} ${selectedClient.apellido}`
                    : ""
                }
                disabled
                type="text"
              />
            </Form.Group>

            <Form.Group className="mb-3" as={Col} lg={3}>
              <Form.Label className="text-primary">Mail:</Form.Label>
              <Form.Control
                className="text-info"
                value={
                  selectedClient.nombre !== undefined
                    ? `${selectedClient.mail}`
                    : ""
                }
                disabled
                type="mail"
              />
            </Form.Group>

            <Form.Group className="mb-3" as={Col} lg={2}>
              <Form.Label className="text-primary">Teléfono:</Form.Label>
              <Form.Control
                className="text-info"
                value={
                  selectedClient.nombre !== undefined
                    ? `${selectedClient.telefono}`
                    : ""
                }
                disabled
                type="text"
              />
            </Form.Group>

            <Form.Group className="mb-3" as={Col} lg={2}>
              <Form.Label className="text-primary">Largo pelo:</Form.Label>
              <Form.Select
                className="text-info"
                onChange={(e) => {
                  handleSelectLargoPelo(e);
                }}
                value={selectedClient.largo_pelo}
                disabled={!selectedClient.nombre}
              >
                {/*<option value={selectedClient.largo_pelo}>
                  {selectedClient.largo_pelo}
                </option>*/}
                <option value={"C"}>C</option>
                <option value={"M"}>M</option>
                <option value={"L"}>L</option>
              </Form.Select>
            </Form.Group>
          </Row>

          <Row className="d-flex justify-content-center">
            <Form.Group className="mb-3" as={Col} lg={10}>
              <Form.Label className="text-primary">Detalle:</Form.Label>
              <Form.Control
                className="text-info"
                as="textarea"
                onChange={(e) => { handleChangeDetalle(e); console.log(e.target.value)}}
                value={
                  selectedClient.nombre !== undefined
                    ? `${detalle}`
                    : ""
                }
                disabled={!selectedClient.nombre}
              />
            </Form.Group>
          </Row>
        </>
      )}
    </>
  );
}

export default ClientesForm;
